import React from "react";
import Index from "../_components/HelpAndSupport/Index";
import HelpAndSupportModal from "../_components/Modals/HelpAndSupportModal";
import { useNavigate } from "react-router-dom";

function HelpAndSupport() {
  const navigate = useNavigate();

  // on clicking of ? icon now it will open the modal
  
  return (
    <HelpAndSupportModal
      show={true}
      onClose={() => {
        navigate("/");
      }}
    />
  );
}

export default HelpAndSupport;
